import { COLLEGE, URL } from "../env/prod/url";
import { COLLEGE as TENANT, URL as DEV_URL } from "../env/url";
import { Auth } from "./auth";

export function getURL(academicLevel) {
    const env=process.env.ENV;
    if(env==="PRODUCTION"){
        return {url:URL(academicLevel!=null?academicLevel:Auth.getAcademicLevel()),college:COLLEGE};
    }else{
        return {url:DEV_URL(academicLevel!=null?academicLevel:Auth.getAcademicLevel()),college:TENANT};
    }
}